import React, { useState } from 'react';
import BreadCrumbBar from '../Layout/Nav/BreadCrumbBar';
import Pagination from 'rc-pagination';
import localeInfo from '../../locale_en_US';
import CONSTANTS from '../../constants';
import UniversalElasticConnectedList from '../UniversalElasticConnectedList';

function FilteredPagedNewsPage({ query, limitFields=null, ghafEnabled=false, tenant }) {
    const numPerPage = 35;
    let [ curPage, setCurPage ] = useState(1);
    let [ numPages, setNumPages ] = useState();
    let [ theEngine ] = useState(ghafEnabled === true ? CONSTANTS.ELASTIC_ENGINES.PUB_AND_GHAF : CONSTANTS.ELASTIC_ENGINES.PUBLIC);



    const filtersToSet = [
        CONSTANTS.FILTER_TYPES.SORT_BY_RECENT, 
        CONSTANTS.FILTER_TYPES.DATE_RANGE_FILTER
    ];

    if(ghafEnabled === true) {
        filtersToSet.push(CONSTANTS.FILTER_TYPES.CATEGORY)
    };

    const onTotalPagesRecvd = (numberOfPages) => {
        setNumPages(numberOfPages);
    }

    const handlePageClick = (pageNum) => {
        setCurPage(pageNum);
    }
    
    return (
        <>
            <BreadCrumbBar appName="NEWS" />

            <h1 className='h1'>News</h1>
            
            <UniversalElasticConnectedList
                engineName={theEngine}
                numPerPage={numPerPage}
                page={curPage}  
                searchTerm={ghafEnabled === true ? '' : query} 
                onTotalPagesReceived={onTotalPagesRecvd} 
                preview={ false } 
                tagQuery={ limitFields && limitFields !== '' }
                tenant={tenant} />
            <div className="text-center">
                { 
                    numPages && numPages > 0 ?
                        <Pagination 
                            total={(numPages*numPerPage)}
                            onChange={ (item) => handlePageClick(item)}
                            pageSize={numPerPage}
                            current={curPage}
                            locale={localeInfo} />
                    : null
                }
            </div>
        </>
    )
}

export default FilteredPagedNewsPage
